function firstString(...values) {
    for (const value of values) {
        if (typeof value === 'string' && value.trim()) return value.trim();
        if (value != null && typeof value !== 'object') {
            const stringValue = String(value).trim();
            if (stringValue) return stringValue;
        }
    }
    return '';
}

function isWordChar(char) {
    return Boolean(char && /[A-Za-z0-9_]/.test(char));
}

function findMatch(haystack, needle) {
    const lowerHaystack = haystack.toLowerCase();
    const lowerNeedle = needle.toLowerCase();
    let fallback = -1;
    let index = lowerHaystack.indexOf(lowerNeedle);
    while (index !== -1) {
        const before = haystack[index - 1] || '';
        const after = haystack[index + needle.length] || '';
        if (!isWordChar(before) && !isWordChar(after)) return index;
        if (fallback === -1) fallback = index;
        index = lowerHaystack.indexOf(lowerNeedle, index + 1);
    }
    return fallback;
}

export function capturedChecklistValues(checklist = {}) {
    return Object.values(checklist || {})
        .filter((item) => item?.captured)
        .map((item) => firstString(item?.value))
        .filter((value, index, values) => value && values.findIndex((candidate) => candidate.toLowerCase() === value.toLowerCase()) === index)
        .sort((a, b) => b.length - a.length);
}

export function highlightCapturedChecklistText(text = '', checklist = {}) {
    const source = typeof text === 'string' ? text : String(text ?? '');
    const values = capturedChecklistValues(checklist);
    if (!source || values.length === 0) return [{ text: source, highlight: false }];

    const ranges = [];
    for (const value of values) {
        const start = findMatch(source, value);
        if (start === -1) continue;
        let end = start + value.length;
        while (/\d/.test(value[value.length - 1] || '') && /\d/.test(source[end] || '')) {
            end += 1;
        }
        if (ranges.some((range) => start < range.end && end > range.start)) continue;
        ranges.push({ start, end });
    }
    if (ranges.length === 0) return [{ text: source, highlight: false }];
    ranges.sort((a, b) => a.start - b.start);

    const segments = [];
    let cursor = 0;
    ranges.forEach((range) => {
        if (range.start > cursor) segments.push({ text: source.slice(cursor, range.start), highlight: false });
        segments.push({ text: source.slice(range.start, range.end), highlight: true });
        cursor = range.end;
    });
    if (cursor < source.length) segments.push({ text: source.slice(cursor), highlight: false });
    return segments;
}
